// import React from "react";
// import GeoIcon from "../../../../assets/images/icons/geo-icon.svg";
// import SearchPlus from "../../../../assets/images/icons/search-plus.svg";
// import MapChart from "./components/MapChart";
// import StarIcon from '../../../../assets/images/icons/start-icon.svg';

// const GeoInsightSection = ({ hasActiveSubscription, onProClick }) => {
//   const [zoom, setZoom] = React.useState(1);

//   const handleZoomIn = () => {
//     setZoom((z) => Math.min(z * 1.5, 4));
//   };

//   const handleZoomOut = () => {
//     setZoom((z) => Math.max(z / 1.5, 1));
//   };

//   return (
//     <div className="info-box h-full bg-theme_clr1 text-white flex flex-col justify-between rounded-xl p-4 xl:p-5">
//       <div className="flex justify-between items-center gap-2 leading-tight mb-4">
//         <div className="flex flex-wrap gap-2">
//           <img
//             src={GeoIcon}
//             alt="GeoMap"
//             className="inline w-[30px] h-[30px] mr-2"
//           />
//           <div className="title-info text-[23px] font-bold font-manrope ">
//             Geo Data
//           </div>
//         </div>
//         <div className="flex gap-2">
//           {/* Show zoom-in button always */}
//           <div onClick={handleZoomIn} className="cursor-pointer">
//             <img
//               src={SearchPlus}
//               alt="Zoom In"
//               className="inline w-[30px] h-[30px]"
//             />
//           </div>

//           {/* Show zoom-out button only when zoomed in */}
//           {zoom > 1 && (
//             <div onClick={handleZoomOut} className="cursor-pointer">
//               <img
//                 src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='white' viewBox='0 0 512 512'><path d='M208 0C93.1 0 0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.5 128-44l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L381.3 326.6c27.5-35.3 44-79.7 44-128C425.3 93.1 332.2 0 208 0zM128 192h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z'/></svg>"
//                 width="30"
//                 height="30"
//                 alt="Search Minus Icon"
//               />
//             </div>
//           )}
//         </div>
//       </div>
//       <div className="relative w-full h-full min-h-[400px]"> {/* Add fixed height container for MapChart */}
//         {hasActiveSubscription ?
//           <MapChart zoom={zoom} setZoom={setZoom} />
//           :
//           <>
//             {/* Greyed Out Overlay */}
//             <div className="absolute inset-0 bg-gray-200/30 backdrop-blur-[2px] z-10 rounded" />
//             <img src={require('../../../../assets/images/world-map.png')}/>
//             {/* Go Pro Button */}
//             <div className="absolute inset-0 z-20 flex items-center justify-center">
//               <button
//                 type="button"
//                 className={`btn-custom3 flex items-center gap-2`}
//                 onClick={onProClick}
//               >
//                 Go Pro
//                 <img
//                   src={StarIcon}
//                   alt="Star"
//                   className="h-[20px] w-[20px] min-w-[20px]"
//                 />
//               </button>
//             </div>
//           </>
//         }
//       </div>
//     </div>
//   );
// };

// export default GeoInsightSection;

import React, { useState, useRef, useEffect, useMemo } from "react";
import { Search, X } from "lucide-react";
import { useSelector } from "react-redux";
import GeoIcon from "../../../../assets/images/icons/geo-icon.svg";
import SearchPlus from "../../../../assets/images/icons/search-plus.svg";
import MapChart from "./components/MapChart";
import StarIcon from '../../../../assets/images/icons/start-icon.svg';

const GeoInsightSection = ({ hasActiveSubscription, onProClick }) => {
  const [zoom, setZoom] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const searchRef = useRef(null);

  const audienceDetails = useSelector((state) => state.dataanalyst);
  const { geoDetails } = audienceDetails;
  const geoData = useMemo(
    () => (geoDetails?.length > 0 ? geoDetails : []),
    [geoDetails]
  );

  const handleZoomIn = () => {
    setZoom((z) => Math.min(z * 1.5, 16));
  };

  const handleZoomOut = () => {
    setZoom((z) => Math.max(z / 1.5, 1));
  };

  // Handle search input
  useEffect(() => {
    if (searchQuery.trim() === "") {
      setSearchResults([]);
      setShowResults(false);
      return;
    }

    const query = searchQuery.toLowerCase();
    const results = geoData.filter((location) =>
      location.name.toLowerCase().includes(query)
    );
    setSearchResults(results);
    setShowResults(true);
  }, [searchQuery, geoData]);

  // Close search results when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (searchRef.current && !searchRef.current.contains(event.target)) {
        setShowResults(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const clearSearch = () => {
    setSearchQuery("");
    setSearchResults([]);
    setShowResults(false);
  };

  return (
    <div className="info-box h-full bg-theme_clr1 text-white flex flex-col justify-between rounded-xl p-4 xl:p-5">
      <div className="flex justify-between items-center gap-2 leading-tight mb-4">
        <div className="flex flex-wrap gap-2 items-center">
          <img
            src={GeoIcon}
            alt="GeoMap"
            className="inline w-[30px] h-[30px] mr-2"
          />
          <div className="title-info text-[23px] font-bold font-manrope">
            Geo Data
          </div>

          {/* Search Bar */}
          {hasActiveSubscription && (
            <div className="ml-4 w-64" ref={searchRef}>
              <div className="relative">
                <div className="relative flex items-center">
                  <Search className="absolute left-3 text-gray-400" size={18} />
                  <input
                    type="text"
                    placeholder="Search locations..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onFocus={() => searchQuery && setShowResults(true)}
                    className="w-full pl-10 pr-10 py-1.5 rounded-lg bg-transparent border border-gray-300 text-white text-sm shadow-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent"
                  />
                  {searchQuery && (
                    <button
                      onClick={clearSearch}
                      className="absolute right-3 text-gray-400 hover:text-gray-600"
                    >
                      <X size={18} />
                    </button>
                  )}
                </div>

                {/* Search Results Dropdown */}
                {showResults && searchResults.length > 0 && (
                  <div className="absolute top-full mt-2 w-full bg-white rounded-lg shadow-xl border border-gray-200 max-h-64 overflow-y-auto z-50">
                    {searchResults.map((location, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          setSearchQuery("");
                          setShowResults(false);
                        }}
                        data-location={JSON.stringify(location)}
                        className="w-full px-4 py-3 text-left hover:bg-orange-50 border-b border-gray-100 last:border-b-0 transition-colors"
                      >
                        <div className="font-medium text-gray-900">{location.name}</div>
                        <div className="text-sm text-gray-500">
                          Peak: {location.peak_listeners || 0} | Current: {location.current_listeners || 0}
                        </div>
                      </button>
                    ))}
                  </div>
                )}

                {/* No Results Message */}
                {showResults && searchQuery && searchResults.length === 0 && (
                  <div className="absolute top-full mt-2 w-full bg-white rounded-lg shadow-xl border border-gray-200 px-4 py-3 z-50">
                    <p className="text-gray-500 text-sm">No locations found</p>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        <div className="flex gap-2">
          {/* Show zoom-in button always */}
          <div onClick={handleZoomIn} className="cursor-pointer">
            <img
              src={SearchPlus}
              alt="Zoom In"
              className="inline w-[30px] h-[30px]"
            />
          </div>

          {/* Show zoom-out button only when zoomed in */}
          {zoom > 1 && (
            <div onClick={handleZoomOut} className="cursor-pointer">
              <img
                src="data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' fill='white' viewBox='0 0 512 512'><path d='M208 0C93.1 0 0 93.1 0 208s93.1 208 208 208c48.3 0 92.7-16.5 128-44l128 128c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L381.3 326.6c27.5-35.3 44-79.7 44-128C425.3 93.1 332.2 0 208 0zM128 192h160c8.8 0 16 7.2 16 16s-7.2 16-16 16H128c-8.8 0-16-7.2-16-16s7.2-16 16-16z'/></svg>"
                width="30"
                height="30"
                alt="Search Minus Icon"
              />
            </div>
          )}
        </div>
      </div>
      <div className="relative w-full h-full min-h-[400px]">
        {hasActiveSubscription ?
          <MapChart
            zoom={zoom}
            setZoom={setZoom}
            searchResults={searchResults}
            onSearchSelect={(location) => {
              setSearchQuery("");
              setShowResults(false);
            }}
          />
          :
          <>
            {/* Greyed Out Overlay */}
            <div className="absolute inset-0 bg-gray-200/30 backdrop-blur-[2px] z-10 rounded" />
            <img src={require('../../../../assets/images/world-map.png')} />
            {/* Go Pro Button */}
            <div className="absolute inset-0 z-20 flex items-center justify-center">
              <button
                type="button"
                className={`btn-custom3 flex items-center gap-2`}
                onClick={onProClick}
              >
                Go Pro
                <img
                  src={StarIcon}
                  alt="Star"
                  className="h-[20px] w-[20px] min-w-[20px]"
                />
              </button>
            </div>
          </>
        }
      </div>
    </div>
  );
};

export default GeoInsightSection;
